import React from 'react';
import { ConnectWallet } from '@thirdweb-dev/react';

// Parchment & Stone styled ConnectWallet.
//
// Dark slate base, oxidised-brass border, Cormorant serif voice — this
// is the header control that replaces the Ghost Citizen pill on the
// /global route. Thirdweb v4's theme tokens are limited so we lean on
// the `style` override + a className that CSS further tightens.

const BASE_STYLE: React.CSSProperties = {
  background:    'linear-gradient(180deg, #1a1200 0%, #0f172a 100%)',
  border:        '1px solid #78350f',
  borderRadius:  20,
  color:         '#fcd34d',
  fontFamily:    "'Cormorant Garamond', 'Georgia', serif",
  fontStyle:     'italic',
  fontSize:      13,
  padding:       '6px 16px',
  letterSpacing: '0.04em',
  boxShadow:     '0 0 12px rgba(161,98,7,0.25), inset 0 0 0 1px rgba(252,211,77,0.08)',
  cursor:        'pointer',
};

export default function WalletConnectPill(): React.JSX.Element {
  return (
    <ConnectWallet
      theme="dark"
      modalSize="compact"
      btnTitle="⚱ Connect to the Agora"
      style={BASE_STYLE}
      className="agora-wallet-pill"
      switchToActiveChain
    />
  );
}
